import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IHistoryColumnData } from '../../../../interfaces/history.interface';
import { get } from 'lodash';

@Component({
  selector: 'gen-history-table-item',
  templateUrl: './history-table-item.component.html',
  styleUrls: ['./history-table-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryTableItemComponent implements OnInit {
  @Input() historyRow: any;
  @Input() historyColumn: IHistoryColumnData;
  private cellData: string;

  constructor() { }

  ngOnInit() {
    this.cellData = get(this.historyRow, this.historyColumn.key, '');
  }
}
